import { createSlice } from "@reduxjs/toolkit";

export const homeSlice = createSlice({
  name: "home",
  initialState: {
    showSolicitudAmnistia: false,
    showModalNuevoPromocion: false,
    showSolicitudesDemanda: false,
    component: 1,
  },
  reducers: {
    onShowSolicitudAmnistia: (state) => {
      state.showSolicitudAmnistia = !state.showSolicitudAmnistia;
    },
    onShowModalSolicitudAmnistia: (state) => {
      state.showModalNuevoPromocion = !state.showModalNuevoPromocion;
    },
    onShowModalSolcitudesDemanda: (state) => {
      state.showSolicitudesDemanda = !state.showSolicitudesDemanda;
    },
    onChangeComponent: (state, { payload }) => {
      state.component = payload;
    },
    onResetHome:(state)=>{
      state.showSolicitudAmnistia= false;
      state.showModalNuevoPromocion= false;
      state.showSolicitudesDemanda= false;
      state.component= 1;
    }
  },
});

//actions creators are generated for each case reducer function
export const {
  onShowSolicitudAmnistia,
  onShowModalSolicitudAmnistia,
  onShowModalSolcitudesDemanda,
  onChangeComponent,
  onResetHome
} = homeSlice.actions;
